export const AnchorLinks = (function () {
	'use strict';

	let $win, $anchorLink;

	function init() {
		$win = jQuery(window);
		$anchorLink = $('a[href*="#"]');

		if (location.hash) {
			if ($(location.hash).length > 0 && !$(location.hash).hasClass('modal') ) {
				$win.on('load', function(){
					setTimeout(function(){
						scrollToEl(location.hash);
					}, 500);
				});
			}
		}

		$anchorLink.click(function (e) {
			let href = $(this).attr('href');
			let hrefSplit = href.split('#');
			let id = '#'+hrefSplit[1];

			if (id.length > 1 && $(id).length > 0 && !$(id).hasClass('modal') ) {
				e.preventDefault();
				scrollToEl(id);
			}
		});
	}

	function scrollToEl(id) {
		let headerH = $('.site-header').outerHeight();
		$(document).scrollTop( $(id).offset().top - headerH );
	}

	return {
		init: init,
	};
})();
